var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablethours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.944,
    height: 34.078,
    viewBox: "0 0 47.944 34.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.944,
    height: 34.078,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tablet_hours",
    "data-name": "tablet hours",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4437",
    "data-name": "Path 4437",
    d: "M-14387.83,5197.264v-10.932h-36.025v24.583h24.5",
    transform: "translate(14427.006 -5182.926)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4438",
    "data-name": "Path 4438",
    d: "M-14397.973,5213.525h-24.867s-3.686.175-3.74-2.892,0-23.3,0-23.3-.006-3.758,3.74-3.936,37.417,0,37.417,0,3.73-.252,3.751,3.936,0,11.524,0,11.524",
    transform: "translate(14427.103 -5182.82)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9537",
    "data-name": "Ellipse 9537",
    transform: "translate(29.531 15.665)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.207,
    cy: 9.207,
    rx: 9.207,
    ry: 9.207,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.207,
    cy: 9.207,
    rx: 8.707,
    ry: 8.707,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4439",
    "data-name": "Path 4439",
    d: "M9.473.127A.547.547,0,0,0,8.7.2L4.208,4.158.934,2.415a.547.547,0,0,0-.774.774l3.7,2.166a.547.547,0,0,0,.387.16h.025a.548.548,0,0,0,.4-.2L9.544.9A.547.547,0,0,0,9.473.127Z",
    transform: "translate(32.83 25.294) rotate(-48)",
    fill: "#c4151c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14866",
    "data-name": "Rectangle 14866",
    transform: "translate(8.768 9.078)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14867",
    "data-name": "Rectangle 14867",
    transform: "translate(8.768 16.078)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 3,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablethours);
export default __webpack_public_path__ + "static/media/tablet hours.19a54a8325d2fd9aa064d783961d490b.svg";
export { ForwardRef as ReactComponent };